import React from 'react';
import { connect } from 'react-redux';

import { CardHeader as Header } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

import { _ } from '../../functions/translator.js';

class EmptyCardsGroupHeader extends React.Component{
    
    render() {   
        let pendingIconSrc = require('../../resources/pending.svg')

        return (
            <div>
                <Grid container justify="space-between">
                    <Header
                        avatar={<Avatar alt='Pending' src={ pendingIconSrc }/>}
                        title={`${this.props.customcard.attributes.name} N°${this.props.cardsGroup.attributes.index}`}
                        subheader={_('Este registro aún no se envía')}
                        >
                    </Header>
                </Grid>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {}
}


export default connect(mapStateToProps)(EmptyCardsGroupHeader)